import React from 'react';
export function Footer() {
  return <footer className="bg-[#2A1F17] text-beige/60 py-12 border-t border-olive/20" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-62">
          <div className="text-center md:text-left" data-id="element-63">
            <h3 className="text-xl font-serif font-bold mb-1" data-id="element-64">
              <span className="text-olive-light" data-id="element-65">La Cocina</span>{' '}
              <span className="text-gold" data-id="element-66">que Vende</span>
            </h3>
            <p className="text-sm text-beige/50" data-id="element-67">
              Meriendas Saludables Congeladas
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-68">
            <span className="flex items-center gap-2" data-id="element-69">
              <svg className="w-4 h-4 text-olive" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-70">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-71"></path>
              </svg>
              Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-72">
              <svg className="w-4 h-4 text-olive" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-73">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-74"></path>
              </svg>
              Soporte básico
            </span>
            <span className="flex items-center gap-2" data-id="element-75">
              <svg className="w-4 h-4 text-olive" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-76">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-77"></path>
              </svg>
              Compra segura
            </span>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center text-xs text-beige/40" data-id="element-78">
          <p data-id="element-79">
            &copy; {new Date().getFullYear()} La Cocina que Vende. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}